<template>
  <div class="main_container">
  	<van-nav-bar
		  title="通讯录"
      :fixed="true"
		/>
    <div class="body">
      
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-search placeholder="输入名字搜索" v-model="searchInfo" />
      <van-cell-group style="padding-bottom: 58px;min-height: calc(100vh - 140px);">
        <div class="block_title">分组 <i @click="onClickRight" v-if="userInfo.Role=='admin'" class="el-icon-plus add_icon"></i></div>
        <van-cell-swipe v-if="userInfo.Role == 'admin' " :right-width="65" v-for="group in userGroupsFiltered" :key="group.contact_group_id">
          <van-cell-group>
            <van-cell  :title="group.group_name" is-link @click="$router.push({name:'userGroup',params:{group_id:group.contact_group_id}})"/>
          </van-cell-group>
          <span @click="deleteGroup(group)" slot="right">删除</span>
        </van-cell-swipe>

        <van-cell-group v-if="userInfo.Role != 'admin' ">
          <van-cell v-for="group in userGroupsFiltered" :key="group.contact_group_id" :title="group.group_name" is-link @click="$router.push({name:'userGroup',params:{group_id:group.contact_group_id}})"/>
        </van-cell-group>

        <div class="block_title">联系人<i @click="addUserShow=true" v-if="userInfo.Role=='admin'" class="el-icon-plus add_icon"></i></div>

        <van-cell-swipe v-if="userInfo.Role == 'admin' " :right-width="65" v-for="user in userListFiltered" :key="user.user_id">
          <van-cell-group>
            <van-cell  :title="user.alianame || user.username" is-link @click="$router.push({name:'peopleDetail',params:{people_id:user.user_id}})" :value="user.contact_group_name"/>
          </van-cell-group>
          <span @click="deleteUser(user)" slot="right">删除</span>
        </van-cell-swipe>

        <van-cell v-if="userInfo.Role != 'admin' " v-for="user in userListFiltered" :title="user.alianame || user.username" :key="user.user_id" @click="$router.push({name:'peopleDetail',params:{people_id:user.user_id}})" :value="user.contact_group_name"/>
      </van-cell-group>
      <van-dialog
        v-model="addGroupShow"
        show-cancel-button
        :closeOnClickOverlay="true"
        :before-close="beforeClose"
      >
        <van-field
          v-model="group_name"
          label="组名"
          required
          placeholder="请输入组名"
        />
      </van-dialog>

      <van-dialog
        v-model="addUserShow"
        :closeOnClickOverlay="true"
        show-cancel-button
        @confirm="addUser"
        @cancel="addUserShow=false"
      >
        <van-field
          v-model="username"
          label="手机号："
          required
        />
        <van-field
          v-model="alianame"
          label="昵称："
          required
        />
        <van-field
          v-model="password"
          label="密码："
          type="password"
          required
        />
        <van-field
          v-model="passwordConfirm"
          label="确认密码："
          type="password"
          required
        />
        <van-cell-group>
          <van-switch-cell v-model="userFullfunction" title="用户功能：" />
        </van-cell-group>
      </van-dialog>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast,CellSwipe,Dialog  } from 'vant';
import _ from 'lodash'
export default {
  name: 'HelloWorld',
  data () {
    return {
    	isLoading:false,
      msg: 'Welcome to Your Vue.js App',
      searchInfo:'',
      userListFiltered:[],
      group_name:'',
      addGroupShow:false,
      userGroupsFiltered:[],
      addUserShow:false,
      username:'',
      alianame:'',
      password:'',
      passwordConfirm:'',
      userFullfunction: true
    }
  },
  mounted(){
  	this.onRefresh()
  },
  watch:{
    searchInfo(){
      this.searchChange()
    },
    userList(){
    	this.searchChange()
    }
  },
  computed:{
  	scHeight:function(){
      return ''+document.documentElement.clientHeight - 138
    },
    ...mapState(['userInfo', 'userGroups','userList'])
  },
  methods:{
  	searchChange:_.debounce(function(){
      var regex = new RegExp(this.searchInfo, 'i');
      this.userListFiltered=this.userList.filter(x=>regex.test(x.alianame)||regex.test(x.name))
      this.userGroupsFiltered=this.userGroups.filter(x=>regex.test(x.group_name))  
    },300),
    onRefresh(){
    	this.$store.dispatch('getUserList')
    	this.$store.dispatch('getUserByGroups')
    	setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },
  	onClickRight(){
  		this.addGroupShow = true
  	},
  	beforeClose(action, done) {
  		var self = this
      if (action === 'confirm') {
      	console.log(this.group_name)
      	if (!this.group_name){
      		Toast('组名不为空');
      		done()
      		return 
      	}
      	this.axios_base.get('session/addCusGroup?group_name='+this.group_name+'&app_id='+siteConfig.app_id).then(function(resp){
      		console.log(resp.data)
      		self.onRefresh()
      		done()
      	})
        
      } else {
        done();
      }
    },
    deleteGroup(group){
    	var self = this
    	Dialog.confirm({
			  title: '提示',
			  message: '确认删除组 ' + group.group_name+' ?' 
			}).then(() => {
			  self.axios_base.get("session/deleteCusGroup?group_id="+group.contact_group_id).then(function(resp){
			  	self.onRefresh()
			  })
			}).catch(() => {
			  // on cancel
			});
    },
    addUser(){
    	var self = this
      if(!this.username){
        Toast('请输入有效手机号');
        this.addUserShow = true
        return
      }
      if(!this.alianame){
        Toast('请输入有效昵称');
        this.addUserShow = true
        return
      }
      if(this.password.length < 6){
        Toast('密码长度至少六位');
        this.addUserShow = true
        return 
      }
      if(this.password != this.passwordConfirm){
        Toast('两次输入密码不一致'); 
        this.addUserShow = true
        return 
      }
      var fullfunc = 1
      if (!this.userFullfunction){
        fullfunc = 0
      }
      var data = {
        name: this.username,
        password: this.password,
        alianame: this.alianame,
        station_group_ids: this.userInfo.StationGroupIds,
        app_id: siteConfig.app_id,
        fullfunc:fullfunc
      }
      this.axios_base.post('session/addUser',{data:data}).then(function(resp){
        console.log(resp.data)
        self.onRefresh()
      })
    },
    deleteUser(user){
      var self = this
      console.log(user)
      var name = user.alianame
      if (!name){
        name = user.username
      }
      Dialog.confirm({
        title: '提示',
        message: '确认删除用户 ' + name +' ?' 
      }).then(() => {
        self.axios_base.get("session/deleteUser?user_id="+user.user_id).then(function(resp){
          self.onRefresh()
        })
      }).catch(() => {
        // on cancel
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add_icon{
	float: right;padding-right: 30px;font-size: 20px
}
</style>



// WEBPACK FOOTER //
// src/pages/people/peopleList.vue